<template>
  <div
    v-if="!cbPage"
    class="earlyScreening"
    :style="{ overflow: showPopup ? 'hidden' : 'scroll' }"
  >
    <div class="headFixation" v-if="signCode">检测码：{{ signCode }}</div>
    <div class="earlyTitle">大健康检测报名表</div>
    <div class="earlyHint">
      所有信息请仔细查阅，并认真如实填写。如信息有误，造成一切结果和责任，由本人承担
    </div>
    <div class="form">
      <van-form @submit="onSubmit">
        <div class="form_item" v-for="(item, index) in pSignInfo.arrs" :key="index">
          <van-field required :rules="[{ required: true, message: '请选择性别' }]"  :name="item.code" :label="item.value" v-if="item.select" :readonly="applyInfo.name">
            <template #input>
              <van-radio-group   v-model="item.name"  direction="horizontal">
                <van-radio v-for="(value, key) in item.select" :key="key" :name="key">{{  value  }}</van-radio>
              </van-radio-group>
            </template>
          </van-field>

          <van-field
            v-else-if="item.code === 'cardNo'"
            :value="cardNo"
            :name="item.code"
            :label="getLabels(item.code, item.value)"
            required
            maxlength="18"
            :placeholder="'请输入' + item.value"
            :rules="getRules(item.code, item.value)"
            @click="applyInfo.name?'':showCardNoKeyboard = true"
            @blur="showCardNoKeyboard = false"
            readonly
          />

          <van-field
            v-else-if="item.code === 'phone'"
            :value="phone"
            :name="item.code"
            :label="getLabels(item.code, item.value)"
            required
            maxlength="11"
            :placeholder="'请输入' + item.value"
            :rules="getRules(item.code, item.value)"
            @click="show = true"
            @blur="show = false"
            readonly
          />

          <van-field
            v-model="item.name"
            :name="item.code"
            :label="getLabels(item.code,item.value)"
            required
            :placeholder="'请输入' + item.value"
            :rules="getRules(item.code,item.value)"
            :readonly="applyInfo.name"
            v-else
          />
        </div>

        <!-- 身份证数字键盘 -->
        <van-number-keyboard
          :show="showCardNoKeyboard"
          extra-key="X"
          close-button-text="完成"
          maxlength="18"
          @blur="showCardNoKeyboard = false"
          @close="showCardNoKeyboard = false"
          v-model="cardNo"
        />

         <!-- 数字键盘 -->
         <van-number-keyboard
          :show="show"
          close-button-text="完成"
          maxlength="11"
          @blur="show = false"
          @close="show = false"
          v-model="phone"
        />

        

        <!-- <div class="form_item" v-for="(item, index) in pSignSurvey.arrs" :key="index">
          <van-field v-if="item.type==1" required :rules="[{ required: true, message: '请选择'+item.title }]"  :name="'select'+index" :label="item.title">
            <template #input>
              <van-radio-group   v-model="item.name" direction="horizontal">
                <van-radio v-for="(value, key) in item.select" :key="key" :name="key">{{  value  }}</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field v-else required :rules="[{ required: true, message: '请选择'+item.title }]"  :name="'select'+index" :label="item.title">
            <template #input>
             <van-checkbox-group v-model="item.name" direction="horizontal">
              <van-checkbox shape="square"  v-for="(value, key) in item.select" :key="key" :name="key">{{  value  }}</van-checkbox>
             </van-checkbox-group>
            </template>
          </van-field>
          <van-field
            v-if="item.describe"
            required
            type="textarea"
            :name="'remark'+index"
            autosize
            v-model="remark"
            placeholder="_____________________________________"
          />
        </div>

        <div class="form_item">
          <div class="informed_consent">
            {{ pSignLetter.title }}
            <div class="required">*</div>
          </div>
          <div class="informed_consent_deatil">
            {{  pSignLetter.values  }}
          </div>
        </div>
        <div class="statement">
          <div class="statement_declaration">
            声明
            <div class="required">*</div>
          </div>
          <div class="statement_declaration_detail">
            1）如您在本平台“中科泰康高科技产业（广州）有限公司“购买
            了“泛肿瘤风险筛查项目 ” （
            14项肿瘤的代谢组学泛癌风险筛查），请在下单前与您的分享服务人员进行采血预约（采血前，请务必确保您是在合法合规的医疗机构、并由具备专业资质的医护人员进行操作。如果您发现有任何不符合规定的情况，有权向平台反映或投诉）
          </div>
          <div class="statement_declaration_detail">
            2）“本健康调查问卷”及“知情同意书”仅做日常健康行为参考，将递交一份给成都泰莱高仁医学检验实验室有限公司检测并出具检测报告，在未得到您本人许可，不会透露给无关方，亦不会用到任何商业用途。本公司保留对问卷及报告的说明、解释和更新的权利。
          </div>
          <div class="statement_declaration_detail">
            3）本人（受检人或其监护人）已阅读知情同意书且对条款理解清楚，同意进行上述的肿瘤的代谢组学泛癌风险筛查，且承诺提供的所有问卷信息准确属实。
            如因本人代签或签署信息不准确，造成的一切法律纠纷问题由签署人全责承担。
          </div>
          <div class="statement_declaration_detail">
            4）特别说明：早筛下单人员分享电子早筛码给受检人签署健康问卷书与知情同意书，一个早筛码只能一个人签署，只能签署一次，不能修改。线上填写资料与线下纸质版健康问卷书与知情同意书填写资料必须真实且一致，如果信息不匹配，将可能收不到检测报告，由此产生的一切法律问题和纠纷，由其本人承担。
          </div>
          <div class="statement_declaration_detail">检测者声明：</div>
          <div class="statement_declaration_detail">本人已阅读知情同意书且对条款理解清楚，同意进行上述的泛肿瘤普早筛检测。 *</div>
          <div class="signature_name" @click="onShowPopup">
            <img class="avatarImage" :src="signUrl" />
            检测者签名（正楷）：____________
          </div>
        </div> -->
        <div class="next_step" v-if="!applyInfo.name">
          <van-button round block type="info" native-type="submit">
            我填完了，提交
          </van-button>
        </div>

        <div style="height:200px" v-if="pSignInfo.arrs && (pSignInfo.arrs.length === 4||pSignInfo.arrs.length === 5)"></div>
        <!-- <CanvasSignature v-if="showPopup" :show="showPopup" @close="onHidePopup" @confirm="onChanCanvas" /> -->
        <!-- <van-button
            :color="signUrl?'#003F6A':'#FCFCFC'"
            type="primary"
            @click="onSubmitter"
            :disabled="signUrl?false:true"
        >
            我填完了，提交
        </van-button> -->
      </van-form>
    </div>
  </div>
  <div class="earlyScreening" v-else>
    <div class="qr_code" v-if="extData&&extData.qrCode">
        <img :src="extData.qrCode"/>
    </div>
    <div class="tips">
      操作说明:<br/>
      请下载保存二维码图片，然后使用微信打开识别保存的图片，填写问卷及同意书
    </div>
    <div class="next_step">
      <van-button round block type="info" @click="toHome">
        返回
      </van-button>
    </div>
  </div>
</template>
  
  <script>
import Vue from "vue";
import {
  Image as VanImage,
  Field,
  RadioGroup,
  Radio,
  Popup,
  DatetimePicker,
  Button,
  Form,
  Checkbox, 
  CheckboxGroup,
  Toast,
  NumberKeyboard
} from "vant";
import { getImgUrl } from "@/utils/tools";
import teamApi from "@/apis/check-registration-form";
import CanvasSignature from '@/components/canvas-signature'
import upload from "@/utils/upload";
Vue.use(VanImage);
Vue.use(Form);
Vue.use(Field);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Popup);
Vue.use(DatetimePicker);
Vue.use(Button);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Toast);
Vue.use(NumberKeyboard);
export default {
  data() {
    return {
      pSignInfo: {},
      pSignLetter: {},
      pSignSurvey: {},
      remark: '',
      token: '',
      list: null,
      code: "",
      signCode: '',
      name: "",
      sender: "",
      genderShow: false,
      cardNo: "",
      phone: "",
      showPopup: false,
      signUrl: "",
      id: "",
      skuId: '',
      spuId: '',
      appOrderSn: '',
      shareMemberId: '',
      show: false,
      showCardNoKeyboard: false,
      applyInfo: {},
      extData: null,
      cbPage: false,
    };
  },
  components: {
    CanvasSignature
  },
  watch:{
    showCardNoKeyboard(val, oldVal) {
      if (val) {
        window.scrollTo({top: 10000})
      }
    }
  },
  created() {
    const { query } = this.$route;
    console.log('query',query)
    this.skuId=query.skuId
    this.spuId=query.spuId
    this.appOrderSn=query.appOrderSn
    this.signCode=query.signCode
    this.shareMemberId=query.shareMemberId
    this.phone = query.phone
    this.wxapp_id=query.wxapp_id
    this.subOrderSn=query.subOrderSn
    if (this.wxapp_id) {
      window.sessionStorage.setItem('isClinic', 1)
    }
    if(this.$store.state.appInfo.isApp){
      this.$bridge.callHandler('getUserInfo',{},(res) => {
        const d = JSON.parse(res)
        this.token = d.data.accessToken
        this.init(true)
      })
    }else{
      const { query } = this.$route;
      this.token = query.token
      this.init()
    }
  },
  mounted() {

  },
  methods: {
    getImgUrl,
    touchMove() {
      return;
    },
    init() {
      teamApi.getAppSignUpInfo({ skuId: this.skuId, wxapp_id:this.wxapp_id },{ token:this.token }).then((res) => {
        if (res.code == 0) {
           this.pSignInfo=res.data.pSignInfo
           this.pSignLetter=res.data.pSignLetter
           this.pSignSurvey=res.data.pSignSurvey
           this.extData = res.data.extData
           if(this.subOrderSn){
           //报名结果回填
           teamApi.applyInfo({ subOrderSn: this.subOrderSn  },{ token: this.token }).then(res=>{
              if(res.code==0){
                console.log('res',res.data)
                this.applyInfo=res.data
                // 假设res.data包含了你需要的表单数据
                const formData = res.data;
                this.signCode=formData.signCode
                // 将API返回的数据分配到表单模型中
                this.pSignInfo.arrs.forEach(item => {
                  if (item.code === 'cardNo') {
                    this.cardNo = formData.cardNo; // 如果字段是身份证号
                  } else if (item.code === 'phone') {
                    this.phone = formData.phone; // 如果字段是电话号码
                  } else if (item.code === 'sender') {
                    item.name = `${formData.sender}`
                  } else {
                    item.name = formData[item.code]; // 其他字段
                  }
                });
              }
            }).catch(error => {
              console.error('Error fetching data:', error);
            });
           }
        }
      });

    },
    getLabels(code,value) {
      switch (code) {
        case 'name':
          return value+'（与身份证姓名一致）'
        case 'sender':
          return value;
        case 'age':
          return value;
        case 'height':
          return value+'（cm）';
        case 'weight':
          return value+'（kg）';
        case 'cardNo':
          return value+'号';
        case 'phone':
          return value+'（请输入方便联系的电话号码）';
        default:
          return [{ required: true }];
      }
    },
    getRules(code,value) {
      switch (code) {
        case 'name':
          return [
            { required: true },
            { min: 2, max: 12, message: '姓名长度应在2到12个字符之间' }
          ];
        case 'sender':
          return [
            { required: true }
          ];
        case 'age':
          return [
            { required: true },
            { pattern: /^\d+$/, message: '年龄必须是数字' },
          ];
        case 'height':
          return [
            { required: true },
            { pattern: /^\d+(\.\d+)?$/, message: '身高必须是数字，并且可以包含小数' },
          ];
        case 'weight':
          return [
            { required: true },
            { pattern: /^\d+(\.\d+)?$/, message: '体重必须是数字，并且可以包含小数' },
          ];
        case 'cardNo':
          return [
            { required: true },
            { pattern: /^.{18}$/, message: '身份证号格式不正确' }
          ];
        case 'phone':
          return [
            { required: true },
            { pattern: /^1[3-9]\d{9}$/, message: '手机号码格式不正确' },
          ];
        default:
          return [{ required: true }];
      }
    },
    onChangeRadio(event) {
      this.sender = event.detail;
    },
    ageShow() {
      this.genderShow = true;
    },
    genderShowClose() {
      this.genderShow = false;
    },
    genderConfirm({ detail }) {
      (this.age = detail.value), this.genderShowClose();
    },
    onShowPopup() {
      this.showPopup=true
    },
    onHidePopup() {
      this.showPopup=false
    },
    async base64toFile(urlData) {
      //去掉url的头，并转换为byte
      const bytes = window.atob(urlData.split(",")[1]);
      //处理异常,将ascii码小于0的转换为大于0
      const ab = new ArrayBuffer(bytes.length);
      const ia = new Uint8Array(ab);
      ia.forEach((i, index) => {
        ia[index] = bytes.charCodeAt(index);
      });
      //文件流转换成url路径
      const resetName = `${Math.random()}${+new Date()}`.split(".")[1] + ".png";
      const link = await upload(
        new Blob([ia], {
          type: urlData.split(",")[0].split(":")[1].split(";")[0],
          name: +new Date(),
        }),
        resetName
      );
      return link;
    },
    async onChanCanvas(avatarUrl) {
      console.log('avatarUrl',avatarUrl)
      this.signUrl=await this.base64toFile(avatarUrl);
      this.showPopup=false
    },
    toHome() {
      if (this.wxapp_id) {
        wx.miniProgram.reLaunch({url: '/pages/index/index'})
      } else {
        wx.miniProgram.reLaunch({url: '/pages/home/index'})
      }
    },
    onSubmit(values) {
      console.log('submit',values)
      let { skuId, spuId, appOrderSn, signCode, shareMemberId }= this;
      try {
        const params = {
          ...values,
          skuId,
          spuId,
          appOrderSn,
          signCode,
          shareMemberId,
          // other: [
          //   {
          //     index: 5,
          //     title: this.pSignSurvey.arrs[0].title,
          //     select: values.select0,
          //     remark: "",
          //   },
          //   {
          //     index: 6,
          //     title: this.pSignSurvey.arrs[1].title,
          //     select: values.select1,
          //     remark: "",
          //   },
          //   {
          //     index: 7,
          //     title: this.pSignSurvey.arrs[2].title,
          //     select: values.select2,
          //     remark: "",
          //   },
          //   {
          //     index: 8,
          //     title: this.pSignSurvey.arrs[3].title,
          //     select: values.select3,
          //     remark: "",
          //   },
          //   {
          //     index: 9,
          //     title: this.pSignSurvey.arrs[4].title,
          //     select: values.select4,
          //     remark: values.select4 == 1 ? values.remark4 : "",
          //   },
          // ],
          // signUrl: this.signUrl,
          // agreeRemark: [],
        };
        teamApi.detectApply(params,{ token:this.token }).then(res=>{
           console.log('res',res)
           if(res.code==0){
             Toast('报名成功');
             if (this.extData) {
               this.cbPage = true
             } else {
                setTimeout(()=>{
                  this.toHome()
                },2000)
             }
            
           }
          //  if (res.code==80301) {
          //   Toast('报名成功');
          //   if (this.extData) {
          //      this.cbPage = true
          //    } else {
          //       setTimeout(()=>{
          //         this.toHome()
          //       },2000)
          //    }
          //  }
        })
      } catch (error) {
        console.log("error", error);
      }
    },
  },
};
</script>
  
<style lang="scss" scoped>
.earlyScreening {
  overflow: auto;
  background-color: #fff;
  padding-bottom: 50px;
}

.earlyScreening .required {
  display: inline-block;
  color: red;
}

.headFixation {
  width: 100%;
  height: 17px;
  font-size: 12px;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  font-weight: 500;
  color: #ffffff;
  background: #717171;
  position: fixed;
  z-index: 9999;
}

.earlyTitle {
  text-align: center;
  margin: 25px auto;
  margin-top: 25px;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  font-weight: 500;
  color: #333333;
  font-size: 26px;
}

.earlyHint {
  font-size: 14px;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  font-weight: 500;
  color: #cd0303;
  line-height: 19px;
  text-align: center;
  margin: 20px;
}

.earlyScreening .form {
  padding-bottom: 20px;
}

.earlyScreening .form_item {
  background-color: #EFF5F9;
  margin-bottom: 10px;
  padding: 10px;
  color: #333333;
  font-size: 15px;
  font-weight: 500;
}

.van-cell{
  background-color: #EFF5F9;
}

.earlyScreening .form_item_hint {
  font-size: 12px;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  font-weight: 500;
  color: #aa2f2f;
}

.earlyScreening .marck {
  background-color: #f6eef1;
}

.earlyScreening .van-radio {
  margin-bottom: 20px;
}

.earlyScreening .van-radio__icon {
  background-color: #fff;
}
.earlyScreening .van-radio__icon--checked {
  background-color: var(--radio-checked-icon-color, #1989fa);
  border-color: var(--radio-checked-icon-color, #1989fa);
  color: #fff;
}

.earlyScreening .van-checkbox {
  margin-bottom: 10px;
}

.earlyScreening .van-checkbox__icon {
  background-color: #fff;
}
.earlyScreening .van-checkbox__icon--checked {
  background-color: var(--checkbox-checked-icon-color, #1989fa);
  border-color: var(--checkbox-checked-icon-color, #1989fa);
  color: #fff;
}

.input_highlight {
  // background-color: #eef4fb;
  margin-bottom: 10px;
}

.informed_consent {
  font-size: 10px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: 700;
  color: #333333;
  line-height: 19px;
  text-align: center;
}

.informed_consent_deatil {
  font-size: 14px;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  font-weight: 500;
  color: #333333;
  line-height: 21px;
  margin-top: 10px;
}

.statement {
  padding: 10px;
  background-color: #f6eef1;
  line-height: 21px;
  font-weight: 500;
  color: #333333;
  font-size: 15px;
}
.statement_declaration {
  font-size: 18px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: 700;
  color: #333333;
  line-height: 19px;
  text-align: center;
}

.statement_declaration_detail {
  font-size: 14px;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  font-weight: 500;
  color: #333333;
  line-height: 21px;
  margin-top: 10px;
}

.signature_name {
  color: #aa2f2f;
  font-weight: bold;
  margin: 50px 0 10px 75px;
  position: relative;
}

.avatarImage {
  width: 75px;
  height: 50px;
  position: absolute;
  right: 50px;
  bottom: 10px;
}

.earlyScreening .next_step {
  margin: 20px auto;
  text-align: center;
  display: flex;
  justify-content: center;
}

.earlyScreening .next_step button {
  width: 330px;
  height: 49px;
  background: linear-gradient(95deg, #ff6e53 0%, #ff0000 100%);
  border: none;
  box-shadow: 0px 6px 12px 0px rgba(229, 53, 47, 0.4);
  border-radius: 8px 8px 8px 8px;
  opacity: 1;
  color: #fff;
}

.earlyScreening .arrows {
  color: #838383;
  display: inline-block;
  font-size: 17px;
  font-weight: bold;
  margin-left: 12px;
  width: 15px;
  height: 15px;
}

.qr_code {
  margin: 20px 0;
  text-align: center;

  img {
    width: 80%;
  }
}

.tips {
  color: red;
  margin: 20px 0;
  padding: 0 20px;
}
</style>
  